import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { 
    scenarioIndex: Number,
    importUrl: String,
    scenarios: Array
  }
  
  async import(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const scenarioIndex = parseInt(button.dataset.scenarioImportScenarioIndexValue)
    const scenario = this.scenariosValue[scenarioIndex]
    
    // Disable button and show loading state
    button.disabled = true
    const originalContent = button.innerHTML
    button.innerHTML = this.loadingHTML()
    
    try {
      const response = await fetch(this.importUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ scenario_data: JSON.stringify(scenario) })
      })
      
      const data = await response.json()
      
      if (data.success) {
        // Update button to show success
        button.classList.remove('bg-orange-600', 'hover:bg-orange-500', 'focus-visible:outline-orange-600')
        button.classList.add('bg-green-600', 'hover:bg-green-600', 'cursor-not-allowed')
        button.innerHTML = this.successHTML()
        button.disabled = true
      } else {
        // Show error
        alert('Failed to import scenario: ' + (data.errors || ['Unknown error']).join(', '))
        
        // Reset button
        button.disabled = false
        button.innerHTML = originalContent
      }
    } catch (error) {
      alert('Failed to import scenario: ' + error.message)
      
      // Reset button
      button.disabled = false
      button.innerHTML = originalContent
    }
  }
  
  loadingHTML() {
    return `
      <svg class="mr-1.5 -ml-0.5 animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Importing...
    `
  }
  
  successHTML() {
    return `
      <svg class="mr-1.5 -ml-0.5 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      Imported
    `
  }
}